import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {
  @Input() public data$;

  constructor(public activeModal: NgbActiveModal) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  onConfirm() {
    this.activeModal.close(true);
  }

  onCancel() {
    this.activeModal.close(false);
  }

  onExtraOptionClick() {
    this.activeModal.close('extraOption');
  }
}
